import { Component, OnInit, ElementRef } from '@angular/core';
import {  ViewChild } from '@angular/core';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";
import * as Moment from "../../../../node_modules/moment/moment.js"

import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';
@Component({
  selector: 'app-fe-oaksoccerclub-google-calendar',
  templateUrl: './fe-oaksoccerclub-google-calendar.component.html',
  styleUrls: ['./fe-oaksoccerclub-google-calendar.component.css']
})
export class FeOaksoccerclubGoogleCalendarComponent implements OnInit {

  totalroomevents:RoomEvents[];
  roomevents_arena:RoomEvents[];
  roomA:RoomEvents[];
  roomB:RoomEvents[];
  roomC:RoomEvents[];
  roomD:RoomEvents[];

  EventsToBeShownOnTheInterface;

  roomevents_Commroom1:RoomEvents[];

  public event_array_arena:Event_array_arena[];
  public event_roomA:Event_array_room[];
  public event_roomB:Event_array_room[];
  public event_roomC:Event_array_room[];
  public event_roomD:Event_array_room[];
  public event_ShooterpadB:Event_array_room[];
  public event_Commroom1:Event_array_room[];

  public Event_start_time:string[];
  public Event_end_time:string[];
  public Today_date:string;
  public Clock_date:string;

  public Event_room_name:string;

  timeanddatenow;
  
  public event_counter_arena:number;
  public event_counter_room:number;

  

  constructor(private route: ActivatedRoute,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) {

    setInterval(() => {
       this.refreshData();
    }, 10000);
  

    $("#slideshow > div:gt(0)").hide();

    // setInterval(() => { 
    //   $('#slideshow > div:first')
    //     .fadeOut(500)
    //     .next()
    //     .fadeIn(500)
    //     .end()
    //     .appendTo('#slideshow');
    // },  7000);


   }

  ngOnInit() {
    this.event_counter_arena=0;
    this.event_counter_room=0;
    $("#slideshow > div:gt(0)").hide();
    this.refreshData();
    
  }

  format_time= (date_obj) => {
    // formats a javascript Date object into a 12h AM/PM time string
    var hour = date_obj.getHours();
    var minute = date_obj.getMinutes();
    var amPM = (hour > 11) ? "PM" : "AM";
    if(hour > 12) {
      hour -= 12;
    } else if(hour == 0) {
      hour = "12";
    }
    if(minute < 10) {
      minute = "0" + minute;
    }
    return hour + ":" + minute +" "+ amPM;
   }


   refreshData = ()=>{
    console.log("getting data")
      // let account_id = this.route.snapshot.paramMap.get('id');
      // console.log(account_id)
       ////Date////
       var d = new Date();
       this.timeanddatenow = new Date(d.getTime());  // Create a new Date object to set the current time
       var currentDate = d.getTime();
       var currentDate_start = d.setHours(0, 0, 0, 0); // Reset hours, minutes, seconds and milliseconds
       var endOfDay = new Date(d.getTime());  // Create another new Date object to represent the end of the day
       endOfDay.setHours(23, 59, 59, 999); // Set hours, minutes, seconds and milliseconds to represent the end of the day
       var currentDate_end = endOfDay.getTime();
     //
    
       this.totalroomevents = [];
    // var account_id = 'wnnw';
    // A
       this.getdataService.getGoogleCalendarData('f6knhbfo413pd0ai8s2g9ksje0@group.calendar.google.com').subscribe((roomevents) => {
         for(let i=0; i<roomevents.length ; i++){
          this.totalroomevents.push(roomevents[i])  ;
         }
        //B
        this.getdataService.getGoogleCalendarData('97nb2a3frbr7iftob7c85mhlv4@group.calendar.google.com').subscribe((roomevents) => {
          for(let i=0; i<roomevents.length ; i++){
            this.totalroomevents.push(roomevents[i])  ;
           }
           //C
           this.getdataService.getGoogleCalendarData('cdlr3u16c8k4lkouve6pkeu6eg@group.calendar.google.com').subscribe((roomevents) => {
            for(let i=0; i<roomevents.length ; i++){
              this.totalroomevents.push(roomevents[i])  ;
             }
             //D
             this.getdataService.getGoogleCalendarData('dq1i1bqn98grf7g8cata9idb1k@group.calendar.google.com').subscribe((roomevents) => {
              for(let i=0; i<roomevents.length ; i++){
                this.totalroomevents.push(roomevents[i])  ;
               }
       

                          console.log("data")
                                    console.log(this.totalroomevents)
                                    this.roomA = [];
                                    this.roomB = [];
                                    this.roomC = [];
                                    this.roomD = [];
                                    ////console.log(roomevents)
                                    var x=0;
                                    var y=0;
                                    var z=0;
                                    var c=0;

                                    //separate arrays//
                                    let tobeshownroomevents: EventsToBeShown[];
                                    tobeshownroomevents = [];
                                    let alreadyadded = false;
                                    for(let i=0; i<this.totalroomevents.length; i++)
                                    {
                                     //
                                      // console.log(this.totalroomevents[i].summary);
                                      // console.log("current date: ",currentDate_start);
                                      let startDate = new Date(this.totalroomevents[i].start.dateTime).getTime();
                                      // console.log("start date: ", startDate)
                                      let endDate = new Date(this.totalroomevents[i].end.dateTime).getTime();
                                      // console.log("end date: ",endDate)
                                      
                                      if(startDate>currentDate_start && endDate<currentDate_end  && endDate>currentDate)
                                      {
                                        tobeshownroomevents.push({timestamp:'',A_name:'',B_name:'',C_name:'',D_name:''})
                                   
                                       // console.log(this.totalroomevents[i]);

                                      //  console.log(this.totalroomevents[i].end.dateTime)
                                        console.log(tobeshownroomevents)
                                      for(let v=0; v<tobeshownroomevents.length ; v++){
                                        console.log(this.totalroomevents[i].summary)
                                        console.log("Time stamps")
                                        //console.log("added already ",tobeshownroomevents[v].timestamp)
                                        console.log(tobeshownroomevents[v])
                                        if(tobeshownroomevents[v].timestamp == this.totalroomevents[i].start.dateTime){
                                          if(this.totalroomevents[i].organizer.displayName =='A')
                                          {
                                            console.log("added to A s")
                                            console.log(tobeshownroomevents[v].timestamp)
                                            console.log(tobeshownroomevents[v].A_name)
                                            console.log(tobeshownroomevents[v].B_name)
                                            console.log(tobeshownroomevents[v].C_name)
                                            console.log(tobeshownroomevents[v].D_name)
                                            console.log(v)
                                            tobeshownroomevents[v] = {timestamp:tobeshownroomevents[v].timestamp,A_name:this.totalroomevents[i].summary,B_name:tobeshownroomevents[v].B_name,C_name:tobeshownroomevents[v].C_name,D_name:tobeshownroomevents[v].D_name}
                                            alreadyadded = true; 
                                          }else if(this.totalroomevents[i].organizer.displayName =='B'){
                                            console.log("added to B s")
                                            tobeshownroomevents[v] = {timestamp:this.totalroomevents[i].start.dateTime,A_name:tobeshownroomevents[v].A_name,B_name:this.totalroomevents[i].summary,C_name:tobeshownroomevents[v].C_name,D_name:tobeshownroomevents[v].D_name}
                                            alreadyadded = true;
                                          }else if(this.totalroomevents[i].organizer.displayName =='C - Palermo Orthodontics'){
                                            console.log("added to C s")
                                            tobeshownroomevents[v] = {timestamp:this.totalroomevents[i].start.dateTime,A_name:tobeshownroomevents[v].A_name,B_name:tobeshownroomevents[v].B_name,C_name:this.totalroomevents[i].summary,D_name:tobeshownroomevents[v].D_name}
                                            alreadyadded = true;
                                            
                                          }else if(this.totalroomevents[i].organizer.displayName =='D - Desanno Stucco'){
                                            console.log("added to D s")
                                            tobeshownroomevents[v] = {timestamp:this.totalroomevents[i].start.dateTime,A_name:tobeshownroomevents[v].A_name,B_name:tobeshownroomevents[v].B_name,C_name:tobeshownroomevents[v].C_name,D_name:this.totalroomevents[i].summary}
                                            alreadyadded = true;
                                          }
                                          //tobeshownroomevents.splice(i,1)
                                          
                                          break;
                                         
                                        }
                                      }
                                      if(!alreadyadded){
                                        if(this.totalroomevents[i].organizer.displayName =='A')
                                        {
                                          console.log("added to A")
                                          tobeshownroomevents[i] = {timestamp:this.totalroomevents[i].start.dateTime,A_name:this.totalroomevents[i].summary,B_name:'',C_name:'',D_name:''}
                                          
                                        }else if(this.totalroomevents[i].organizer.displayName =='B'){
                                          console.log("added to B")
                                          tobeshownroomevents[i] = {timestamp:this.totalroomevents[i].start.dateTime,A_name:'',B_name:this.totalroomevents[i].summary,C_name:'',D_name:''}
                                          
                                        }else if(this.totalroomevents[i].organizer.displayName =='C - Palermo Orthodontics'){
                                          console.log("added to C")
                                          tobeshownroomevents[i] = {timestamp:this.totalroomevents[i].start.dateTime,A_name:'',B_name:'',C_name:this.totalroomevents[i].summary,D_name:''}
                                          
                                          
                                        }else if(this.totalroomevents[i].organizer.displayName =='D - Desanno Stucco'){
                                          console.log("added to D")
                                          tobeshownroomevents[i] = {timestamp:this.totalroomevents[i].start.dateTime,A_name:'',B_name:'',C_name:'',D_name:this.totalroomevents[i].summary}
  
                                        }
                                      }
                                       alreadyadded = false;
                                     
                                     
                                       
                                      }
                                    }
                                    console.log(tobeshownroomevents);
                                    for(let z=0;z<tobeshownroomevents.length; z++){
                                      if(tobeshownroomevents[z].timestamp == ''){
                                        tobeshownroomevents.splice(z,1);
                                        z--;
                                      }
                                    }

                                    tobeshownroomevents = this.sortByKey(tobeshownroomevents,'timestamp');

                                    this.EventsToBeShownOnTheInterface = [];

                                    // this.EventsToBeShownOnTheInterface = tobeshownroomevents;
                                    for(let p=this.event_counter_arena;p<tobeshownroomevents.length;p++)
                                    {
                                     this.EventsToBeShownOnTheInterface.push(tobeshownroomevents[p])
                                    }
                                    console.log(tobeshownroomevents);
                                  //   this.event_array_arena=[];
                                  //   this.roomevents_arena = this.sortByKey(this.roomevents_arena,'start','dateTime');
                                  // console.log("arena room events: ",this.roomevents_arena)
                                  //   for(let i=this.event_counter_arena; i<this.roomevents_arena.length; i++)
                                  //   {    

                                  //     let startDate = new Date(this.roomevents_arena[i].start.dateTime).getTime();
                                  //     let endDate = new Date(this.roomevents_arena[i].end.dateTime).getTime();
                                      
                                  //     console.log("inputting data", startDate)

                                  //       this.event_array_arena[x]={Event_id:x,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
                                  //       this.event_array_arena[x].Event_name=this.roomevents_arena[i].summary ;
                                  //        this.event_array_arena[x].Event_room= this.roomevents_arena[i].location;
                                  //         var  date = new Date(startDate);
                                  //       this.event_array_arena[x].Event_start_time=this.format_time(date).toString();
                                  //       this.event_array_arena[x].Event_start_time_number = startDate;
                                  //       date = new Date(endDate);
                                  //       this.event_array_arena[x].Event_end_time=this.format_time(date).toString() ;
                                  //       this.event_array_arena[x].Event_end_time_number = endDate;
                                  //       this.event_array_arena[x].Event_Host_Name=this.roomevents_arena[i].organizer.displayName;
                                        
                                  //       x++;
                                        
                                      
                                  //   }
                                    
                                    //   this.event_counter_arena=this.event_counter_arena+7;
                                     console.log("counter ",this.event_counter_arena);
                                     console.log("length ",tobeshownroomevents.length);
                                    this.event_counter_arena=this.event_counter_arena+7;
                                     if(this.event_counter_arena >= tobeshownroomevents.length)
                                     {
                                      this.event_counter_arena=0;
                                     }


                              //////////////////////////////////////rooms/////////////////////////////////////////////////
                                    // this.event_roomA=[];
                                    // console.log("Red Pad events:",this.roomA)
                                    // this.roomA = this.sortByKey(this.roomA,'start','dateTime');

                                    // for(let i=this.event_counter_room; i<this.roomA.length; i++)
                                    // {
                                    //   var startDate = new Date(this.roomA[i].start.dateTime).getTime();
                                    //   var endDate = new Date(this.roomA[i].end.dateTime).getTime();
                                    //   ////console.log("start date of the event in general:");
                                    //   ////console.log("Check_Start Date: "+startDate);
                                    //   ////console.log("Check_currentDate: "+currentDate);

                                    //   if(startDate>currentDate_start && endDate<currentDate_end  && endDate>currentDate)
                                    //   {
                                    //     console.log("counting valid events")
                                    //     /////event name/////
                                    //     console.log("event name");
                                    //     console.log(this.roomA[i].event_name);
                                    //     ////console.log(y);
                                    //     this.event_roomA[y]={Event_id:y,Event_name:'',Event_room:'',Event_start_time_number:0,Event_start_time:'',Event_end_time_number:0,Event_end_time:'',Event_Host_Name:''}
                                    //     this.event_roomA[y].Event_name=this.roomA[i].summary ;
                                    //     this.event_roomA[y].Event_room=this.roomA[i].event_room ;
                                    //       var  date = new Date(startDate);
                                    //     this.event_roomA[y].Event_start_time=this.format_time(date).toString();
                                    //     this.event_roomA[y].Event_start_time_number = startDate;
                                    //     date = new Date(endDate);
                                    //     this.event_roomA[y].Event_end_time=this.format_time(date).toString() ;
                                    //     this.event_roomA[y].Event_end_time_number = endDate;
                                    //     ////console.log(this.event_array_room[y].Event_end_time);
                                    //     this.event_roomA[y].Event_Host_Name=this.roomA[i].event_host_name;
                                        
                                    //     y++;
                                    //     //////current meeting fetch////////
                                        
                                    //   }
                                    // }


                                    


        
        },
        err=>{
          //////console.log(err);
          return false;
        });
        },
        err=>{
          //////console.log(err);
          return false;
        });
        },
        err=>{
          //////console.log(err);
          return false;
        });
         ////end of getting calendars///////////////
    },
    err=>{
      //////console.log(err);
      return false;
    });
    
   }


   sortByKey(array, key) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}


}



interface RoomEvents{
  _id:number,
  event_name:string,
  summary:string,
  organizer,
  start,
  end,
  location,
  event_room:string,
  event_room_id:string,
  event_place:string,
  event_start_time:Date,
  event_start_time_readable:string,
  event_end_time_readable:string,
  event_end_time:Date,
  event_logo:string,
  event_logo_path:string,
  event_host_name:string,
  event_attendants:string[]
}

interface EventsToBeShown{
  timestamp:string,
  A_name:string,
  B_name:string,
  C_name:string,
  D_name:string
}

interface Event_array_arena{
  Event_id:number,
  Event_name:string,
  Event_room:string,
  Event_start_time:string,
  Event_start_time_number:number,
  Event_end_time:string,
  Event_end_time_number:number,
  Event_Host_Name:string
}

interface Event_array_room{
  Event_id:number,
  Event_name:string,
  Event_room:string,
  Event_start_time:string,
  Event_start_time_number:number,
  Event_end_time:string,
  Event_end_time_number:number,
  Event_Host_Name:string
}


// WEBPACK FOOTER //
// ./src/app/components/fe-oaksoccerclub-google-calendar/fe-oaksoccerclub-google-calendar.component.ts